import React, { useRef } from 'react';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { handleScroll } from './Navbar';

gsap.registerPlugin(ScrollTrigger);

const packages = [
  {
    title: 'חבילת שיפור ק"ח',
    color: 'from-pink-100 to-pink-50',
    border: 'border-pink-200',
    btn: 'bg-pink-500 hover:bg-pink-600',
    items: [
      'שיחת היכרות',
      'שדרוג מלא של קורות החיים',
      'התאמה לתחום העיסוק',
    ],
  },
  {
    title: 'חבילת בסיס מורחבת',
    color: 'from-purple-100 to-purple-50',
    border: 'border-purple-200',
    btn: 'bg-purple-500 hover:bg-purple-600',
    featured: true,
    items: [
      'שיחת היכרות',
      'שדרוג מלא של קורות החיים',
      'התאמה לתחום העיסוק',
      'הכנה לראיון עבודה',
    ],
  },
  {
    title: 'חבילת פרימיום',
    color: 'from-purple-300 to-purple-200',
    border: 'border-purple-400',
    btn: 'bg-purple-700 hover:bg-purple-800',
    items: [
      'שיחת היכרות',
      'שדרוג מלא של קורות החיים',
      'התאמה לתחום העיסוק',
      'הכנה לראיון עבודה אישיותי',
      'הכנה לראיון עבודה טכני',
      'סדנת עולם הגיוס לינקדין וראיון טלפוני',
      'ליווי אישי ועזרה בחיפוש משרות מתאימות',
    ],
  },
];

const Packages = () => {
  const containerRef = useRef(null);

  useGSAP(() => {
    gsap.from('.package-card', {
      y: 80,
      autoAlpha: 0,
      duration: 0.8,
      stagger: 0.2,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: '.packages-grid',
        start: 'top 75%',
      },
    });
  }, { scope: containerRef });

  return (
    <section ref={containerRef} className="py-20 px-8 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="text-4xl font-bold text-gray-800 mb-3">חבילות ייעוץ</h2>
          <p className="text-gray-500 text-lg">בחר את החבילה המתאימה לך</p>
        </div>

        <div className="packages-grid grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
          {packages.map((pkg, i) => (
            <div
              key={i}
              className={`package-card bg-gradient-to-b ${pkg.color} border ${pkg.border} p-8 rounded-2xl shadow-lg text-center transition-transform duration-200 hover:-translate-y-1 hover:shadow-xl ${pkg.featured ? 'ring-2 ring-purple-400' : ''}`}
            >
              {pkg.featured && (
                <span className="inline-block mb-3 text-xs font-semibold bg-purple-500 text-white px-3 py-1 rounded-full uppercase tracking-wide">
                  הכי פופולרי
                </span>
              )}
              <h3 className="text-xl font-bold mb-6 text-gray-800">{pkg.title}</h3>
              <ul className="mb-8 space-y-3 text-right rtl">
                {pkg.items.map((item, j) => (
                  <li key={j} className="flex items-start gap-2 justify-end text-gray-700">
                    <span>{item}</span>
                    <span className="text-green-500 font-bold mt-0.5">✓</span>
                  </li>
                ))}
              </ul>
              <button
                onClick={() => handleScroll('contact')}
                className={`${pkg.btn} text-white px-6 py-2.5 rounded-full font-medium transition-colors duration-200`}
              >
                לפרטים
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Packages;
